import { PlusBoxMultipleIcon } from './PlusBoxMultipleIcon';

/**
 * author: Google
 * id BF1B666E-57AC-41B0-950B-4F4060BDF601
 * name plus-box-multiple
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/plus-box-multiple.svg
 * tags
 */
export const LibraryAddIcon = PlusBoxMultipleIcon;
export default LibraryAddIcon